import type { TPhysician } from '../types/user';

/**
 * A person is "actively training" when any of their `physician` records has a target
 * speciality set. `physician` is an o2m list, so this checks all of them rather than
 * assuming a single record.
 */
export const hasActiveTraining = (
  user: { physician?: ReadonlyArray<Pick<TPhysician, 'target_speciality'> | null> | null } | null | undefined,
): boolean => (user?.physician ?? []).some((physician) => physician?.target_speciality != null);
